var module = angular.module('octopusApp.shared');

module.factory('templateParameterModal', function ($uibModal, unsavedChanges) {
    function create(templates, options) {
        var name = options.name || 'Variable Template';
        var invalidStepTypes = options.isTemplate ?
            ["StepName"] :["AzureAccount"];
        var requiredPermission = options.requiredPermission || 'ActionTemplateEdit';
        var projectId = options.projectId || '*';

        function addTemplate() {
            return $uibModal.open({
                backdrop: true,
                keyboard: true,
                templateUrl: 'areas/shared/views/edit_parameter_dialog.html',
                controller: 'TemplateParameterEditController',
                dialogClass: 'modal modal-big',
                resolve: {
                    title: function () {
                        return name;
                    },
                    parameter: function () {
                        return {};
                    },
                    names: function () {
                        return _.pluck(templates, 'Name');
                    },
                    invalidStepTypes: function () {
                        return invalidStepTypes;
                    },
                    requiredPermission: function () {
                        return requiredPermission;
                    },
                    projectId: function () {
                        return projectId;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    templates.push(result);
                    unsavedChanges.unsaved();
                    if (options.onChange) {
                        options.onChange();
                    }
                }
            });
        }

        function editTemplate(variableTemplate) {
            return $uibModal.open({
                backdrop: true,
                keyboard: true,
                templateUrl: 'areas/shared/views/edit_parameter_dialog.html',
                controller: 'TemplateParameterEditController',
                dialogClass: 'modal modal-big',
                resolve: {
                    title: function () {
                        return name;
                    },
                    parameter: function () {
                        return _.clone(variableTemplate);
                    },
                    names: function () {
                        return _.pluck(_.without(templates, variableTemplate), 'Name');
                    },
                    invalidStepTypes: function () {
                        return invalidStepTypes;
                    },
                    requiredPermission: function () {
                        return requiredPermission;
                    },
                    projectId: function () {
                        return projectId;
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    templates[_.indexOf(templates, variableTemplate)] = result;
                    unsavedChanges.unsaved();
                    if (options.onChange) {
                        options.onChange();
                    }
                }
            });
        }

        function removeTemplate(variableTemplate) {
            templates.splice(templates.indexOf(variableTemplate), 1);
            unsavedChanges.unsaved();
        }

        return {
            addTemplate: addTemplate,
            editTemplate: editTemplate,
            removeTemplate: removeTemplate
        };
    }

    return {
        create: create
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/template_parameter_modal.js
// module id = 3212718308616303
// module chunks = 1